import * as S from './ProductsPage.styles'
import { useNavigate } from '@remix-run/react'
import {
  AI_GENERATION_URL,
  PHOTO_BOOK_HOMEPAGE_URL,
  PHOTO_STYLER_URL,
} from '../../config/config'
import TopBar from '../../elements/TopBar/TopBar'
import React from 'react'
import useOnMount from '../../hooks/useOnMount'
import { analytics, EVENT_NAMES } from '../../services/Analytics/Analytics'
import { _SCREENS } from '../../services/Analytics/AnalyticsEvents'
import { PRODUCT_TYPES } from '../../services/ProductTypeState'
import smallTilesPhoto from './Assets/SmallScreen/tiles.png'
import smallBooksPhoto from './Assets/SmallScreen/books.png'
import smallAiPhoto from './Assets/SmallScreen/ai.png'
import largeAiPhoto from './Assets/LargeScreen/ai.png'
import largeTilesPhoto from './Assets/LargeScreen/tiles.png'
import largeBooksPhoto from './Assets/LargeScreen/books.png'
import { useExperimentManager } from '../../services/ExperimentManager/ExperimentManager'
import { TILE_CONTENT } from '@mixtiles/web-backend-shared/src/consts/tiles'
import useScreenSize from '../../hooks/useScreenSize'

function ProductsPage() {
  const navigate = useNavigate()
  const experimentManager = useExperimentManager()
  const aiEnabled = experimentManager.isEnabled('ai-templates')
  const isLargeScreen = useScreenSize('md')

  useOnMount(() => analytics.trackScreenView(_SCREENS.PRODUCT_SELECTION_PAGE))

  const navigateToPhotos = () => {
    analytics.track(EVENT_NAMES.PRODUCT_SELECTION_PRODUCT_TAPPED, {
      productType: PRODUCT_TYPES.CLASSIC,
    })
    navigate(PHOTO_STYLER_URL)
  }

  const navigateToPhotoBooks = () => {
    analytics.track(EVENT_NAMES.PRODUCT_SELECTION_PRODUCT_TAPPED, {
      productType: PRODUCT_TYPES.PHOTO_BOOK,
    })
    navigate(PHOTO_BOOK_HOMEPAGE_URL)
  }

  const navigateToAICreation = () => {
    analytics.track(EVENT_NAMES.PRODUCT_SELECTION_PRODUCT_TAPPED, {
      productType: TILE_CONTENT.AI_GEN_PHOTO,
    })
    navigate(AI_GENERATION_URL)
  }

  return (
    <S.PageContainer>
      <TopBar sticky />
      <S.Container>
        <S.Header $aiEnabled={aiEnabled}>Start Creating</S.Header>
        <S.ProductsContainer>
          <S.ProductContainer
            onClick={navigateToPhotos}
            data-testid="products-page-photo-tiles-cta"
          >
            <S.ProductHeader>Photo Tiles</S.ProductHeader>
            <S.ProductImage
              src={isLargeScreen ? largeTilesPhoto : smallTilesPhoto}
            />
          </S.ProductContainer>
          {aiEnabled && (
            <S.ProductContainer onClick={navigateToAICreation}>
              <S.ProductHeader $withTextShadow>Photos to Art</S.ProductHeader>
              <S.ProductImage
                src={isLargeScreen ? largeAiPhoto : smallAiPhoto}
              />
            </S.ProductContainer>
          )}
          <S.ProductContainer onClick={navigateToPhotoBooks} $isPhotoBooks>
            <S.ProductHeader $withTextShadow>Photo Books</S.ProductHeader>
            <S.ProductImage
              src={isLargeScreen ? largeBooksPhoto : smallBooksPhoto}
            />
          </S.ProductContainer>
        </S.ProductsContainer>
      </S.Container>
    </S.PageContainer>
  )
}

export default ProductsPage
